import { Pill, Spoiler } from '@mantine/core';
import { useTranslation } from 'react-i18next';

export interface RecommendedItem {
  label: string;
  key?: string;
  onClick?: () => void;
}

interface RecommendedListProps {
  items: RecommendedItem[];
}

const RecommendedList = ({ items = [] }: RecommendedListProps) => {
  const { t } = useTranslation();

  return (
    <Spoiler
      maxHeight={120}
      showLabel={t('chat.viewMore')}
      hideLabel={t('chat.viewLess')}
      styles={{
        control: {
          textAlign: 'right',
          width: '100%',
        },
      }}
    >
      <Pill.Group style={{ justifyContent: 'end' }}>
        {items?.map((item) => (
          <Pill
            bg="dark.9"
            w="fit-content"
            style={{ cursor: 'pointer' }}
            onClick={() => item.onClick?.()}
            key={item?.key || item.label}
            title={item.label}
          >
            {item.label}
          </Pill>
        ))}
      </Pill.Group>
    </Spoiler>
  );
};

export default RecommendedList;
